define((require) => {
    "use strict";

    var EditorEvents = require("shared/services/EditorEvents"),
        Marionette   = require("marionette"),
        template     = require("ui/settings/breakpoint/AddBreakpointView.tpl");

    /**
     * View for adding new breakpoints.
     *
     * @class AddBreakpointView
     *
     * @cfg {BreakpointCollection} collection The collection of <tt>Breakpoints</tt>'s.
     */
    return Marionette.ItemView.extend("AddBreakpointView", {

        template: template,

        className: "add-breakpoint-view",

        ui: {
            input:  ".new-breakpoint",
            ok:     ".ok",
            cancel: ".cancel"
        },

        events: {
            "click @ui.ok": "confirmAddBreakpoint",
            "click @ui.cancel": "close",
            "keyup @ui.input": "updateInputState"
        },

        updateInputState: function() {
            var value = this.ui.input.val();

            if (parseInt(value, 10) > 0) {
                this.ui.ok.attr("disabled", false);

                if (value.length > 4) {
                    this.ui.input.val(value.slice(0, 4));
                }
            } else {
                this.ui.ok.attr("disabled", true);
            }
        },

        confirmAddBreakpoint: function() {
            var threshold = parseInt(this.ui.input.val(), 10);

            if (threshold > 0 && !this.collection.containsThreshold(threshold)) {
                this.collection.add({threshold: threshold});
            }

            var eventProperties = {
                threshold: threshold,
                triggerOrigin: "AddBreakpointModalOkButton"
            };

            EditorEvents.trigger(EditorEvents.constants.ADD_BREAKPOINT, eventProperties);
            this.close();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/breakpoint/AddBreakpointView.js